import { render, staticRenderFns } from "./ikno.vue?vue&type=template&id=5e541e54&"
import script from "./ikno.vue?vue&type=script&lang=js&"
export * from "./ikno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports